import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/landing/case_img1.webp";
import Logo1 from "../../../images/landing/case-logo-1.webp";
import Img2 from "../../../images/landing/case_img2.webp";
import Logo2 from "../../../images/landing/case-logo-2.webp";
import Img3 from "../../../images/landing/case_img3.webp";
import Logo3 from "../../../images/landing/case-logo-3.webp";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Carousel from "react-bootstrap/Carousel";

const Casebanner = () => {
  return (
    <Carousel indicators={false} pause={false} className="case_landing_slider">
      <Carousel.Item style={{ backgroundColor: "#7BE1E0" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                <div className="case_img">
                  <LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                <div className="case_content">
                  <LazyLoadImage
                    src={Logo1}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                  <h2>OZ Leasing</h2>
                  <p>
                    OZ Leasing, a disruptive tech start-up, aims to simplify car
                    leasing in the automotive industry. Our team developed a
                    comprehensive web and mobile app solution, streamlining the
                    leasing process for users.
                  </p>
                  <h6>Challenges Faced</h6>
                  <ul>
                    <li>Complex and time-consuming car leasing processes</li>
                    <li>Lack of transparency in pricing and terms</li>
                  </ul>
                  <h6>Benefits Delivered</h6>
                  <ul>
                    <li>
                      Reduced leasing time by 40% through an intuitive app
                      interface
                    </li>
                    <li>Enhanced transparency with clear pricing and terms</li>
                  </ul>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item style={{ backgroundColor: "#C9DAD0" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                <div className="case_img">
                  <LazyLoadImage
                    src={Img2}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                <div className="case_content">
                  <LazyLoadImage
                    src={Logo2}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                  <h2> Al Hussaini Trading Company</h2>
                  <p>
                    Al Hussaini Trading Company, a prominent marketplace for
                    watches, jewelry, and leather goods in Saudi Arabia,
                    partnered with us to elevate their online retail presence.
                    We developed a responsive web and app solution to redefine
                    the digital retail experience.
                  </p>
                  <h6>Challenges Faced</h6>
                  <ul>
                    <li>Limited online presence impacting sales</li>
                    <li>Inefficient and outdated e-commerce platform</li>
                  </ul>
                  <h6>Benefits Delivered</h6>
                  <ul>
                    <li>3X online sales within the first six months</li>
                    <li>
                      Improved customer engagement with a user-friendly
                      interface
                    </li>
                  </ul>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
      <Carousel.Item style={{ backgroundColor: "#E2F4FB" }}>
        <section className="case_banner_lp p-100">
          <Container className="h-100">
            <Row className="h-100">
              <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                <div className="case_img">
                  <LazyLoadImage
                    src={Img3}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                <div className="case_content">
                  <LazyLoadImage
                    src={Logo3}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                  />
                  <h2>Linkfront</h2>
                  <p>
                    Linkfront, an innovative shopping web app, approached us to
                    redefine the online retail landscape. We created a dynamic
                    platform that seamlessly integrates with e-commerce
                    websites, offering users a unified shopping experience.
                  </p>
                  <h6>Challenges Faced</h6>
                  <ul>
                    <li>
                      Fragmented shopping experience across multiple online
                      stores
                    </li>
                    <li>
                      Lack of a centralized platform for product discovery
                    </li>
                  </ul>
                  <h6>Benefits Delivered</h6>
                  <ul>
                    <li>
                      Increased user engagement with a one-stop shopping
                      solution
                    </li>
                    <li>
                      Improved conversion rates through a simplified checkout
                      process
                    </li>
                  </ul>
                  <Link to="/projects">View More Projects</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Carousel.Item>
    </Carousel>
  );
};

export default Casebanner;
